import Analytics from '@hh.ru/analytics-js';

export const sendAnalytics = (categoryId: string, positionIndex: number): void => {
    Analytics.sendHHEventButtonClick('vacancy_professional_catalog_item', {
        value: categoryId,
        position: positionIndex,
    });
};
